import { styled } from '../../Utilities';
import { OverflowSetBase } from './OverflowSet.base';
import { getStyles } from './OverflowSet.styles';
export var OverflowSet = styled(OverflowSetBase, getStyles, undefined, {
  scope: 'OverflowSet'
});